export default "__VITE_ASSET__5b6ede8b__"